import { useState } from "react";

import CurrentWorkflowCard from "./CurrentWorkflowCard";
import WorkflowPositionModal from "./WorkflowPositionModal";

export default function WorkflowHeader({
    workflow,
    leadId,
    onRefresh,
    refreshing,
    onWorkflowChanged,
}) {
    const [positionOpen, setPositionOpen] = useState(false);

    return (
        <>
            <CurrentWorkflowCard
                workflow={workflow}
                onRefresh={onRefresh}
                refreshing={refreshing}
                onMove={() => setPositionOpen(true)}
            />
            <WorkflowPositionModal
                open={positionOpen}
                leadId={leadId}
                workflow={workflow}
                onClose={() => setPositionOpen(false)}
                onMoved={onWorkflowChanged}
            />
        </>
    );
}
